import axios from 'axios'
import AxiosInstance from 'utils/AxiosInstance'
import * as types from './constants'

import {
  BASE_URL_API as baseURLNode,
  ACCESS_TOKEN as accessToken,
} from 'utils/helpers'

export const resetTheme = () => {
  return (dispatch, getState) => {
    dispatch(fetchTheme())
  }
}

const setFavicon = (url) => {
  const nodes = document.querySelectorAll('.kiwi-favicon')

  ;[].map.call(nodes, (node) => (node.href = url))
}

const setAppIcon = (url) => {
  const nodes = document.querySelectorAll('.kiwi-app-icon')

  ;[].map.call(nodes, (node) => (node.href = url))
}

export const onImageChange = (file, name) => {
  return (dispatch, getState) => {
    const fileReader = new FileReader()

    fileReader.onload = (evt) => {
      dispatch({
        type: types.THEME_IMAGE_CHANGE,
        name,
        value: { url: evt.target.result },
      })

      if (name === 'favicon') {
        setFavicon(evt.target.result)
      }
    }

    fileReader.readAsDataURL(file)

    dispatch({
      type: types.THEME_IMAGE_FILE,
      name: name + 'File',
      value: file,
    })
  }
}

export const fetchTheme = () => {
  return (dispatch, getState) => {
    AxiosInstance.get('/themes').then((data) => {
      if (data) {
        dispatch({ type: types.THEME, theme: data })
        if (data.favicon && data.favicon.url) {
          setFavicon(data.favicon.url)
        }
        // if (data.appIcon && data.appIcon.url) {
        //   setAppIcon(data.appIcon.url)
        // }
      }
    })
  }
}

export const resetStatus = () => ({ type: types.THEME_STATUS, status: '' })

export const createTheme = () => {
  return (dispatch, getState) => {
    const {
      color,
      navColor,
      navTextColor,
      navIconColor,
      topbarIconColor,
      sidebarBackground,
      sidebarActiveColor,
      sidebarTextColor,
    } = getState().themeConfig.theme
    const {
      logoFile,
      backgroundFile,
      navlogoFile,
      faviconFile,
      loginLogoFile,
      appIconFile,
    } = getState().themeConfig
    const data = new FormData()

    if (logoFile) {
      data.append('logo', logoFile)
    }
    if (backgroundFile) {
      data.append('background', backgroundFile)
    }
    if (navlogoFile) {
      data.append('navlogo', navlogoFile)
    }
    if (faviconFile) {
      data.append('favicon', faviconFile)
    }
    if (loginLogoFile) {
      data.append('loginLogo', loginLogoFile)
    }
    if (appIconFile) {
      data.append('appIcon', appIconFile)
    }
    if (color) {
      data.append('color', color)
    }
    if (navColor) {
      data.append('navColor', navColor)
    }
    if (navTextColor) {
      data.append('navTextColor', navTextColor)
    }
    if (navIconColor) {
      data.append('navIconColor', navIconColor)
    }
    if (topbarIconColor) {
      data.append('topbarIconColor', topbarIconColor)
    }
    if (sidebarBackground) {
      data.append('sidebarBackground', sidebarBackground)
    }
    if (sidebarActiveColor) {
      data.append('sidebarActiveColor', sidebarActiveColor)
    }
    if (sidebarTextColor) {
      data.append('sidebarTextColor', sidebarTextColor)
    }

    return (
      AxiosInstance
        //   .post(`${baseURLNode()}/themes?token=${accessToken()}`, data)
        .post(`/themes?token=${accessToken()}`, data)
        .then(() => dispatch(fetchTheme()))
    )
  }
}

export const handleColorChange = (optionName, value) => {
  return (dispatch) => {
    dispatch({ type: types.SET_THEME_COLORS, name: optionName, value })
  }
}
